module.exports = __webpack_public_path__ + "img/home_banner_banner_default.6ac28699.jpg";